export const NOTE_THICKNESS = 8;
export const TRACE_NOTE_THICKNESS = 4;
export const NOTE_CORNER_RADIUS = 4;
export const GRID_LINE_THICKNESS = 4;
export const COLUMN_SPACING = 70;
export const BEATS_PER_COLUMN = 32;
export const LANE_FLAG_MAX_VALUE = 59; //NEVER CHANGE THIS VALUE

export const CHART_PADDING = 40;
export const FLOAT_COMPARISON_EPSILON = 1e-3;
export const COMBO_COUNT_PADDING = 10;
export const FLICK_ARROW_SIZE = 12;
export const FLICK_ARROW_COLOR = 0x7ad464;
export const HOLD_END_COLUMN_ADJUST = 1e-6;

export const NOTE_COLOR_SINGLE = 0xcc6ad6;
export const NOTE_COLOR_TRACE = 0xdad15a;
export const NOTE_COLOR_HOLD = 0x77f9f9;
export const HOLD_SEGMENT_ALPHA = 0.5;
export const NOTE_COLOR_FLICK = 0x7ad464;
export const CHART_AREA_BACKGROUND_COLOR = 0xf5f5f5;
export const NOTE_COLOR_DEFAULT = 0xffffff;

export const HOLD_NOTE_KEY_DIGITS = 2;
export const HOLD_NOTE_KEY_PRECISION = Math.pow(10, HOLD_NOTE_KEY_DIGITS);

// From ChartRendererDebug.ts
export const DEBUG_HOLD_TICK_LINE_COLOR = 0xff0000;
export const DEBUG_HOLD_TICK_LINE_THICKNESS = 1;

// From ComboCounter.ts
export const BEAT_MAP_KEY_PRECISION = 4;

// Shared constants (if any were identified as truly shared and renamed)
// For now, keeping distinct names as in original files even if values are same,
// e.g. FLICK_ARROW_COLOR and NOTE_COLOR_FLICK

export const FEVER_SECTION_COLOR = 0xffffe0; // Light Yellow
export const FEVER_SECTION_ALPHA = 0.25;
